import { useMutation } from '@tanstack/react-query';

import { updateMailingListsTargetQuantity } from '@enterprise/api';

import type { MutationCallbacks } from '@/types/common/mutation-callbacks.type';

import { useApplicationStore } from '@hooks/application/application-store.hook';

import type { UpdateMailingListsTargetQuantityArgs } from './types/update-mailing-lists-target-quantity-args.type';

export const useUpdateMailingListsTargetQuantity = (options?: MutationCallbacks) => {
  const enterpriseApi = useApplicationStore(({ enterpriseApi }) => {
    return enterpriseApi;
  });

  const { onError, onSuccess } = options ?? {};

  return useMutation({
    mutationFn: async ({ lists, mailingId }: UpdateMailingListsTargetQuantityArgs) => {
      await updateMailingListsTargetQuantity(enterpriseApi, mailingId, lists);
    },

    onError: (error) => {
      onError?.(error);
    },

    onSuccess: () => {
      onSuccess?.();
    },
  });
};
